<se-fe-toast></se-fe-toast>
<router-outlet></router-outlet>
<app-confirm></app-confirm>
